import { instance as axios, setJwtToken } from "../../config/axiosInstance";




// ------------------------Get Faq List------------------
export const getFaqApi = async (data) => {
  const endPoint =
    `faq/list` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// ------------------------Add FAQ------------------
export const addFaqApi = async (data) => {
  const endPoint = `faq/add`;
  return await axios.post(endPoint, data, setJwtToken());
};

// ------------------------Edit faq------------------
export const editFaqApi = async (id,data) => {
  const endPoint = `faq/update/${id}`;
  return await axios.put(endPoint, data, setJwtToken());
};
export const faqView = async (id) => {
  const endPoint = `faq/view/${id}`;
  return await axios.get(endPoint, setJwtToken());
};

// -------------------------Change Faq Status------------
export const changeFaqStatusApi = async (data) => {
  const endPoint = `faq/change_status`;
  return await axios.put(endPoint, data, setJwtToken());
};

// -------------------------Delete Faq ------------
export const deleteFaqApi = async (id) => {
  const endPoint = `faq/delete/${id}`;
  return await axios.delete(endPoint, setJwtToken());
};
